export enum UserRole {
  ADMIN = 'admin',
  INSTRUCTOR = 'instructor',
  COACH = 'coach',
  CUSTOMER = 'customer',
}

export type RoleEnum = UserRole.ADMIN | UserRole.INSTRUCTOR | UserRole.COACH | UserRole.CUSTOMER
export type SystemUserRoleEnum = UserRole.ADMIN | UserRole.INSTRUCTOR | UserRole.COACH
